import Seo from "../components/Seo";

export default function HowItWorks() {
  return (
    <>
      <Seo
        title="How It Works"
        description="How HS Library Hangout plans events and how parents RSVP for their homeschooled teens."
      />
      <h1>How it works</h1>

      <section className="card">
        <h2>1. We plan a gathering</h2>
        <p>
          A new event starts as <strong>Planned</strong>: we&rsquo;ve picked a date and are working on
          reserving a library meeting room. RSVPs are not open yet at this stage.
        </p>
      </section>

      <section className="card">
        <h2>2. The room is confirmed</h2>
        <p>
          Once the room is reserved, the event becomes <strong>Confirmed</strong> and RSVPs open. You&rsquo;ll
          see how many of the teen spots are already reserved.
        </p>
      </section>

      <section className="card">
        <h2>3. You RSVP</h2>
        <p>
          A parent or guardian submits the RSVP for their own teen(s) &mdash; teens do not RSVP for
          themselves. You&rsquo;ll provide your name, email, number of teens attending, and agree to our
          safety and privacy policies.
        </p>
      </section>

      <section className="card">
        <h2>4. You confirm by email</h2>
        <p>
          We send a confirmation link to the email you provided. Clicking it confirms your RSVP (or adds
          you to the waitlist if the event has filled up since you submitted).
        </p>
      </section>

      <section className="card">
        <h2>5. Manage your RSVP any time</h2>
        <p>
          Every confirmation email includes a private link to view, edit, or cancel your RSVP &mdash;
          without needing to create an account or remember a password.
        </p>
      </section>

      <section className="card">
        <h2>6. Attend the gathering</h2>
        <p>
          An adult parent organizer is present for the entire event. Please review our{" "}
          <a href="/safety">Safety &amp; Code of Conduct</a> before attending.
        </p>
      </section>
    </>
  );
}
